import { useRef, useState } from "react";
import {
  fetchBeneficiaries,
  transferFunds,
} from "../../../../network/Apiservices";
import {
  AccountOptionType,
  AccountType,
  beneficiaryType,
  mfaPayloadType,
} from "../../types";
import { deviceType } from "../../../core/utils/types";
import { GroupBase, SelectInstance } from "react-select";
import { validatePayload } from "../../../auth/utils/utility";
import { useLocationContext } from "../../../location/context/locationContext";
import { getCurrentCurrency } from "../../../../utils/currencyFormatter";

interface StateType {
  transactionType: any;
  selectedAccount: { id: string; valuew: AccountType } | null;
  toAccount: { id: string; valuew: AccountType } | null;
  amount: string;
  narration: string;
  beneficiary: beneficiaryType | null;
  toCountry: any;
  showBeneficiarySelector: boolean;
  payees: any[];
  accountsHave: AccountType[];
  otp: string;
  benefeciaries: any[];
  accountsOwe: any[];
  showStotpModal: boolean;
  isDeviceListModelOpen: boolean;
  isManual: boolean;
  isAppoveModelOpen: boolean;
  isResultModalOpen: boolean;
  haveAccountsOptions: AccountOptionType[];
  toAccountOptions: AccountOptionType[];
  approvalStatus: any;
  completedTransactionId: string;
  selectedDevice: deviceType | null;
  mfaPayload: mfaPayloadType | null;
}
const defaultState = {
  transactionType: "",
  selectedAccount: null,
  toAccount: null,
  amount: "",
  narration: "",
  beneficiary: null,
  toCountry: null,
  showBeneficiarySelector: false,
  payees: [],
  accountsHave: [],
  otp: "",
  benefeciaries: [],
  accountsOwe: [],
  showStotpModal: false,
  isDeviceListModelOpen: false,
  isManual: false,
  isAppoveModelOpen: false,
  isResultModalOpen: false,
  haveAccountsOptions: [],
  toAccountOptions: [],
  approvalStatus: null,
  completedTransactionId: "",
  selectedDevice: null,
  mfaPayload: null,
};

interface QuickTransferProps {
  accountsHave: AccountType[];
}

export const QuickTransferActions = (props: QuickTransferProps) => {
  const [state, setState] = useState<StateType>(defaultState);
  const [errorCode, setErrorCode] = useState<string>("");
  const accountSelectorRef = useRef<SelectInstance<
    any,
    boolean,
    GroupBase<any>
  > | null>(null);
  const toAccountSelectorRef = useRef<SelectInstance<
    any,
    boolean,
    GroupBase<any>
  > | null>(null);
  const payeeSelectorRef = useRef<SelectInstance<
    any,
    boolean,
    GroupBase<any>
  > | null>(null);
  const beneficiarySelectorRef = useRef<SelectInstance<
    any,
    boolean,
    GroupBase<any>
  > | null>(null);
  const { locationData } = useLocationContext();

  const startTransfer = async (device?: deviceType) => {
    try {
      let payload = transferPayload(state, device);
      let isValidPayload = validatePayload(payload);
      if (!isValidPayload) {
        return;
      }
      let res: any;
      if (device) {
        let xMfaChallengePayload = {
          ...state.mfaPayload,
          stRegistrationId: device?.id,
        };
        res = await transferFunds(
          state.transactionType,
          payload,
          xMfaChallengePayload
        );
      } else {
        res = await transferFunds(
          state.transactionType,
          payload,
          undefined,
          locationData
        );
      }
      console.log("res", res.data);
      console.log("X-EK-MFA-CHALLENGE-PAYLOAD", res.headers["x-mfa-payload"]);
      const mfaPayload = JSON.parse(res.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]);
      if (mfaPayload.deviceList) {
        setState({
          ...state,
          isDeviceListModelOpen: true,
          isAppoveModelOpen: false,
          mfaPayload: mfaPayload,
        });
        return;
      } else {
        setState({
          ...state,
          isDeviceListModelOpen: false,
          isAppoveModelOpen: true,
          mfaPayload: mfaPayload,
        });
      }

      return JSON.parse(res.headers["X-EK-MFA-CHALLENGE-PAYLOAD"]);
    } catch (error) {
      throw error;
    }
  };

  const onClickPay = async () => {
    try {
      // let res: any = await getMyRegistrationsApiHandler();
      // console.log("res", res);

      startTransfer();
    } catch (error) {
      console.log("error", error);
    }
  };

  const transferPayload = (state: any, device?: deviceType) => {
    console.log("state.transactionType", state.transactionType);

    const payload = {
      transferType: state.transactionType,
      fromAccount: state.selectedAccount?.value.id,
      toAccount: state.toAccount?.value.id,
      amount: `${state.amount}`,
      fromCurrency: getCurrentCurrency().code,
      toCurrency: getCurrentCurrency().code,
      narration: state.narration,
      beneficiaryId: state.beneficiary?.value.id,
      payeeName: state.toAccount?.value.name ?? state.beneficiary?.value.name,
      swiftCode:
        state.transactionType === "INTERNATIONAL_TRANSFER"
          ? state.toCountry?.swiftCodePrefix ?? "AE"
          : undefined,
      sourceOfFunds:
        state.transactionType === "INTERNATIONAL_TRANSFER"
          ? state.narration
          : undefined,
      toCountry:
        state.transactionType === "INTERNATIONAL_TRANSFER" ? "AE" : undefined,
      beneficiaryName:
        state.toAccount?.value.name ?? state.beneficiary?.value.name,
      // deviceId: device?.deviceId ?? null,
    };

    return payload;
  };

  const onSelectType = async (e: any) => {
    let haveAccountsOptions = props.accountsHave.map((d: AccountType) => {
      return { label: d.name, value: d };
    });

    if (e.value !== "OWN_ACCOUNT_TRANSFER") {
      let res = await fetchBeneficiaries(e.value);
      let payees = res.beneficiaries.map((d: beneficiaryType) => {
        return { label: d.name, value: d };
      });
      setState({
        ...state,
        transactionType: e.value,
        haveAccountsOptions,
        payees,
        toAccount: null,
        selectedAccount: null,
        amount: "",
        narration: "",
        beneficiary: null,
      });
    } else {
      setState({
        ...state,
        transactionType: e.value,
        haveAccountsOptions,
        toAccount: null,
        selectedAccount: null,
        amount: "",
        narration: "",
        beneficiary: null,
      });
    }

    if (state.toAccount)
      toAccountSelectorRef.current?.setValue(null, "deselect-option");
    if (state.selectedAccount) accountSelectorRef.current?.clearValue();
    if (state.beneficiary)
      payeeSelectorRef.current?.setValue(null, "deselect-option");
    if (state.beneficiary)
      beneficiarySelectorRef.current?.setValue(null, "deselect-option");
  };

  const toggleApprove = () => {
    setState({
      ...state,
      isAppoveModelOpen: !state.isAppoveModelOpen,
    });
  };

  const toggleResultModal = () => {
    setState({
      ...state,
      isResultModalOpen: !state.isResultModalOpen,
    });
  };

  const navigateToResultModal = () => {
    setState({
      ...state,
      isAppoveModelOpen: false,
      isResultModalOpen: true,
      isDeviceListModelOpen: false,
    });
  };

  const onSelectAccount = (e: any) => {
    if (!e) {
      return;
    }
    if (state.transactionType === "OWN_ACCOUNT_TRANSFER") {
      let toAccounts = state.haveAccountsOptions.filter(
        (d: AccountOptionType) => d.value.id !== e.value.id
      );
      setState({
        ...state,
        selectedAccount: e,
        toAccountOptions: toAccounts,
      });
    } else {
      setState({
        ...state,
        selectedAccount: e,
      });
    }
  };

  const onChangeAmount = (e: any) => {
    const regex = /^[0-9(),.-]+$/;

    if (regex.test(e.target.value) || e.target.value === "") {
      setState((ps) => ({
        ...ps,
        amount: e.target.value,
      }));
    } else return;
  };

  const onSelectPayee = (e: any) => {
    if (!e) {
      return;
    }
    setState({ ...state, beneficiary: e, toAccount: e });
  };

  const onChangeNote = (e: any) => {
    setState({ ...state, narration: e.target.value });
  };

  const setStatus = (status: any) => {
    setState({
      ...state,
      isAppoveModelOpen: false,
      isResultModalOpen: true,
      isDeviceListModelOpen: false,
      approvalStatus: status,
    });
  };

  const onSelectToAccount = (e: any) => {
    if (!e) {
      return;
    }
    setState({ ...state, toAccount: e });
  };

  const toggleDeviceListModel = () => {
    setState({
      ...state,
      isDeviceListModelOpen: !state.isDeviceListModelOpen,
    });
  };

  const navigateToApproveModal = (device: deviceType) => {
    startTransfer(device);
  };

  const setErrorCodeToState = (errorCode?: string) => {
    if (!errorCode) {
      setErrorCode("");
      return;
    }
    setErrorCode(errorCode);
  };

  const setTotp = (e: string) => setState({ ...state, otp: e });

  return {
    onClickPay,
    onSelectType,
    toggleApprove,
    toggleResultModal,
    navigateToResultModal,
    onSelectAccount,
    onChangeAmount,
    onSelectPayee,
    onChangeNote,
    setStatus,
    onSelectToAccount,
    toggleDeviceListModel,
    navigateToApproveModal,
    setTotp,
    state,
    toAccountSelectorRef,
    accountSelectorRef,
    payeeSelectorRef,
    beneficiarySelectorRef,
    setErrorCodeToState,
    errorCode,
  };
};
